import React, { useState } from 'react'
import { NavLink } from 'react-router-dom'

// icons
import { PiSquaresFourThin } from "react-icons/pi";
import { FaWallet } from "react-icons/fa";
import { AiOutlineStock } from "react-icons/ai";
import { RiFileList2Fill } from "react-icons/ri";
import { AiOutlineHistory } from "react-icons/ai";
import { IoIosSettings } from "react-icons/io";
import { MdHelp } from "react-icons/md";
import { IoLogOut } from "react-icons/io5";
import { FaUsers } from "react-icons/fa";
import { FaBalanceScale } from "react-icons/fa";
import { IoChevronBack, IoChevronForward } from "react-icons/io5"; // For collapse/expand toggle

interface Props { }

function SideBar(props: Props) {
  const { } = props
  const [collapsed, setCollapsed] = useState(false);

  const menuList = [
    {
      to: "/",
      icon: <PiSquaresFourThin />,
      label: "Dashboard"
    },
    {
      to: "/add-party",
      icon: <FaWallet />,
      label: "Add Party"
    },
    {
      to: "/Stock",
      icon: <AiOutlineStock />,
      label: "Add Stock"
    },
    {
      to: "/BalanceSheet",
      icon: <FaBalanceScale />,
      label: "Balance Sheet"
    },
    {
      to: "/parties-list",
      icon: <RiFileList2Fill />,
      label: "Parties List"
    },
    {
      to: "/history",
      icon: <AiOutlineHistory />,
      label: "History"
    },
    {
      to: "/users",
      icon: <FaUsers />,
      label: "Users"
    },
    {
      to: "/usershistory",
      icon: <FaUsers />,
      label: "Users History"
    }
  ];

  const generalList = [
    {
      to: "/setting",
      icon: <IoIosSettings />,
      label: "Settings"
    },
    {
      to: "/help",
      icon: <MdHelp />,
      label: "Help"
    },
    {
      to: "/logout",
      icon: <IoLogOut />,
      label: "Logout"
    }
  ];

  return (
    <>
      <aside
        className={
          `sticky top-0 bottom-0 h-[100vh] bg-white transition-all duration-300 
          ${collapsed
            ? "w-[64px] pl-2 pr-2"
            : "w-[220px] md:w-[220px] lg:w-[20%] pl-4 pr-2"
          } flex flex-col justify-between pt-6`
        }
      >
        <div>
          {/* Collapse/Expand button */}
          <div className="flex items-center justify-end mb-4">
            <button
              className="p-2 rounded hover:bg-gray-100"
              onClick={() => setCollapsed((c) => !c)}
              aria-label={collapsed ? 'Expand sidebar' : 'Collapse sidebar'}
              type="button"
            >
              {collapsed
                ? <IoChevronForward className="text-xl" />
                : <IoChevronBack className="text-xl" />
              }
            </button>
          </div>
          <p className={`text-[14px] text-[#8F98B7] ml-2 transition-all duration-200 ${collapsed ? 'opacity-0 w-0 h-0 overflow-hidden' : ''}`}>MENU</p>
          <nav className='flex flex-col mt-[12px]'>
            {menuList.map(({ to, icon, label }) => (
              <NavLink
                key={to}
                to={to}
                className={({ isActive }) =>
                  `flex items-center justify-between gap-2 ${isActive ? 'bg-[#F4F6F8BA]' : ''} py-3 ${collapsed ? '' : 'pl-2'} rounded-[8px] overflow-hidden`
                }
              >
                {({ isActive }) => (
                  <>
                    <div className='flex items-center gap-2'>
                      <div
                        className={`w-[32px] h-[32px] border-[1px] border-[#E7EEEF] rounded-[8px] flex items-center justify-center ${isActive ? 'bg-gradient-to-r from-[#1CAC70] to-[#EDDC46]  text-white' : ''
                          }`}
                      >
                        {/* Fix: Don't assign className prop directly via cloneElement; wrap in span */}
                        <span className={`${isActive ? 'text-[#fff]' : 'text-[#9FA8C7]'}`}>
                          {icon}
                        </span>
                      </div>
                      <span
                        className={
                          `transition-all duration-200 
                            ${collapsed ? 'opacity-0 w-0 h-0 overflow-hidden' : 'opacity-100'} 
                            ${isActive ? 'text-[#3F4765]' : 'text-[#9FA8C7]'} 
                            ${collapsed ? '' : 'inline'} hidden lg:inline`
                        }
                        style={collapsed ? { width: 0, padding: 0, margin: 0 } : {}}
                      >
                        {label}
                      </span>
                    </div>
                    <div
                      className={`${isActive ? (collapsed ? 'hidden' : 'block') : 'hidden'} w-[25px] h-[30px] mr-[-10px]  rounded-l-[50%] bg-gradient-to-r from-[#1CAC70] to-[#EDDC46] `}
                    >
                    </div>
                  </>
                )}
              </NavLink>
            ))}
          </nav>
        </div>
        <div>
          <p className={`text-[14px] text-[#8F98B7] ml-2 transition-all duration-200 ${collapsed ? 'opacity-0 w-0 h-0 overflow-hidden' : ''}`}>GENERAL</p>
          <nav className='flex flex-col mt-[12px]'>
            {generalList.map(({ to, icon, label }) => (
              <NavLink
                key={to}
                to={to}
                className={({ isActive }) =>
                  `flex items-center justify-between gap-2 ${isActive ? 'bg-[#F4F6F8BA]' : ''} py-3 ${collapsed ? '' : 'pl-2'} rounded-[8px] overflow-hidden`
                }
              >
                {({ isActive }) => (
                  <>
                    <div className='flex items-center gap-2'>
                      <div
                        className={`w-[32px] h-[32px] border-[1px] border-[#E7EEEF] rounded-[8px] flex items-center justify-center ${isActive ? 'bg-gradient-to-r from-[#1CAC70] to-[#EDDC46]  text-white' : ''
                          }`}
                      >
                        {/* Fix: Don't assign className prop directly via cloneElement, use a span wrapper */}
                        <span className={`${isActive ? 'text-[#fff]' : 'text-[#9FA8C7]'}`}>
                          {icon}
                        </span>
                      </div>
                      <span
                        className={
                          `transition-all duration-200 
                            ${collapsed ? 'opacity-0 w-0 h-0 overflow-hidden' : 'opacity-100'} 
                            ${isActive ? 'text-[#3F4765]' : 'text-[#9FA8C7]'}
                            ${collapsed ? '' : 'inline'} hidden lg:inline`
                        }
                        style={collapsed ? { width: 0, padding: 0, margin: 0 } : {}}
                      >
                        {label}
                      </span>
                    </div>
                    <div
                      className={`${isActive ? (collapsed ? 'hidden' : 'block') : 'hidden'} w-[25px] h-[30px] mr-[-10px] rounded-l-[50%] bg-gradient-to-r from-[#1CAC70] to-[#EDDC46] `}>
                    </div>
                  </>
                )}
              </NavLink>
            ))}
          </nav>
        </div>
      </aside>
    </>
  )
}

export default SideBar
